interface Props {
  originalPrice: { price: string | number | null } | null;
  currentPrice: { price: string | number | null } | null;
}

export const isDiscounted = (prices: Props): boolean =>
  prices != null && prices.originalPrice && prices.currentPrice
    ? Number(prices.currentPrice.price) < Number(prices.originalPrice.price)
    : true;
